/** Invite codes are always 6 uppercase alphanumeric characters. */
export const INVITE_CODE_LENGTH = 6;
/**
 * Alphabet for invite codes (no I/O/0/1 — avoids ambiguous glyphs). Generator
 * and format validation share this set.
 */
export const INVITE_CODE_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
/** Auto-start delay once every seated player is ready (ms). */
export const LOBBY_AUTO_START_MS = 3_000;
/** Watch-only connections a room admits on top of its player seats. */
export const MAX_SPECTATORS = 20;
/**
 * Dispose a lobby that still has zero seated players after this grace period
 * (covers create-then-never-join and last-player-leave races).
 */
export const LOBBY_EMPTY_DISPOSE_MS = 45_000;
/**
 * How long a live match (setup/playing) holds a disconnected player's seat
 * open for reconnection, in seconds. A page refresh / app reload lands the
 * player back on the lobby hub, which offers "Reconnect" while this window is
 * open. Once it lapses, the transport token expires but the account-owned game
 * seat remains disconnected and can still be reclaimed through the hub or a
 * persisted-room resume.
 */
export const GAME_RECONNECT_GRACE_S = 120;
/** Clamp a requested max-players value into the legal lobby range. */
export function clampLobbyMaxPlayers(raw, minPlayers = 2, absoluteMax = 8) {
    if (!Number.isFinite(raw))
        return absoluteMax;
    return Math.max(minPlayers, Math.min(absoluteMax, Math.floor(raw)));
}
/** Normalize an invite code for lookup / display (trim + uppercase). */
export function normalizeInviteCode(raw) {
    return raw.trim().toUpperCase();
}
/** Shape check for a typed invite code (after normalize) — matches generator. */
export function isValidInviteCodeFormat(code) {
    if (code.length !== INVITE_CODE_LENGTH)
        return false;
    for (const ch of code) {
        if (!INVITE_CODE_ALPHABET.includes(ch))
            return false;
    }
    return true;
}
/** Rows per match-history page (fixed server-side; echoed in the response). */
export const MATCH_HISTORY_PAGE_SIZE = 10;
//# sourceMappingURL=lobby.js.map